// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-wrap[data-v-d78e4944]{position:fixed;z-index:999}.modal-wrap[data-v-d78e4944],.modal-wrap .modal-bg[data-v-d78e4944]{top:0;left:0;width:100%;height:100%}.modal-wrap .modal-bg[data-v-d78e4944]{position:absolute;z-index:-1;background:rgba(0,0,0,.7)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
